import { memo } from 'react';
import { formatDate } from '../../../../../utils/dateFormat';

export { formatDate };

// Memoized status renderer
export const renderStatus = (value) => {
  const statusStyles = {
    'ARRIVED': 'bg-green-100 text-green-800',
    'ACTIVE': 'bg-green-100 text-green-800',
    'DEMOBILIZED': 'bg-blue-100 text-blue-800',
    'IDLE': 'bg-yellow-100 text-yellow-800',
    'PENDING': 'bg-gray-100 text-gray-800'
  };
  
  const style = statusStyles[value?.toUpperCase()] || 'bg-gray-100 text-gray-800';
  
  return (
    <span className={`px-2 py-1 rounded-full text-base ${style}`}>
      {value || "Pending"}
    </span>
  );
};

// Memoized column configuration
export const IDLE_COLUMNS = [
  { key: 'serial', title: 'S.NO.', searchable: false },
  { key: 'point_of_hire', title: 'POINT OF HIRE', searchable: true },
  { key: 'candidate_id', title: 'EMPLOYEE ID', searchable: true },
  { key: 'name', title: 'EMPLOYEE NAME', searchable: true },
  { key: 'nationality', title: 'NATIONALITY', searchable: true },
  { key: 'actual_profession', title: 'ACTUAL PROFESSION', searchable: true },
  { key: 'visa_profession', title: 'VISA PROFESSION', searchable: true },
  { key: 'total_salary', title: 'TOTAL SALARY', searchable: false },
  { key: 'client', title: 'CLIENT', searchable: true },
  { key: 'visa_provider', title: 'VISA PROVIDER', searchable: true },
  { key: 'iqama_number', title: 'IQAMA NUMBER', searchable: true },
  { key: 'iqama_expiry_date_g', title: 'IQAMA EXPIRY DATE', searchable: false },
  { key: 'arrival_date', title: 'ARRIVAL DATE', searchable: false },
  { key: 'mobilization_date', title: 'MOBILIZATION DATE', searchable: false },
  { key: 'demobilization_date', title: 'DEMOBILIZATION DATE', searchable: false },
  { key: 'demobilization_comments', title: 'DEMOBILIZATION COMMENTS', searchable: false },
  { key: 'idle_aging', title: 'IDLE AGING', searchable: false },
  { key: 'demobilization_type', title: 'STATUS', searchable: true },
  { key: 'select', title: 'SELECT', searchable: false }
];

// Constants for better maintainability
export const IDLE_CONFIG = {
  API_ENDPOINT: "/demobilization/idleCandidates/IDLE",
  DOWNLOAD_ENDPOINT: "/demobilization/idleCandidates/download/IDLE",
  DOWNLOAD_FILENAME: "Idle_Employees",
  SEARCH_PLACEHOLDER: "Search idle employees...",
  NO_DATA_MESSAGE: "No idle employees found",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000],
  LEGEND: {
    text: "IQAMA EXPIRING:",
    className: "flex gap-x-2 ml-3 items-center",
    iconClassName: "w-4 h-4 bg-red"
  }
};

// Memoized searchable fields derived from columns
export const IDLE_SEARCHABLE_FIELDS = IDLE_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);

// Memoized Legend Component
export const IqamaExpiryLegend = memo(({ count = 0 }) => (
  <div className={IDLE_CONFIG.LEGEND.className}>
    <div className={IDLE_CONFIG.LEGEND.iconClassName}></div>
    <strong>{IDLE_CONFIG.LEGEND.text}</strong>
    <span className="ml-1 px-2 py-0.5 bg-red text-white rounded-full font-semibold">
      {String(count).padStart(2, '0')}
    </span>
  </div>
));

IqamaExpiryLegend.displayName = 'IqamaExpiryLegend';